import React from 'react';
import styles from './index.module.scss';

const Logout = ({ className }) => {
    return (
        <svg
            id='Group_9348'
            data-name='Group 9348'
            xmlns='http://www.w3.org/2000/svg'
            width='94'
            height='94'
            viewBox='0 0 94 94'
            className={className}
        >
            <circle
                id='Ellipse_115'
                data-name='Ellipse 115'
                cx='47'
                cy='47'
                r='47'
                className={styles.circle}
            />
            <g id='logout' transform='translate(26 26)'>
                <g id='Group_2926' data-name='Group 2926'>
                    <g id='Group_2925' data-name='Group 2925'>
                        <path
                            id='Path_3163'
                            data-name='Path 3163'
                            d='M37.333,0H4.667A4.665,4.665,0,0,0,0,4.667V14H4.667V4.667H37.333V37.333H4.667V28H0v9.333A4.665,4.665,0,0,0,4.667,42H37.333A4.665,4.665,0,0,0,42,37.333V4.667A4.665,4.665,0,0,0,37.333,0Z'
                            className={styles.icon}
                        />
                        <path
                            id='Path_3164'
                            data-name='Path 3164'
                            d='M16.532,105.365l3.3,3.3L31.5,97,19.833,85.333l-3.3,3.3,6.032,6.032H0v4.667H22.563Z'
                            transform='translate(0 -76)'
                            className={styles.icon}
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Logout;
